<template>
  <div class="container">
    <h1>Wordsearch</h1>
    <div class="wordsearch-game">
      <div class="wordsearch-container">
        <svg width="480" height="480" class="wordsearch-overlay">
          <rect v-for="(lasso,idx) in lassos" :key="idx" :class="lasso.class" :width="lasso.width" :height="lasso.height" :x="lasso.x" :y="lasso.y" :rx="lasso.rx" :ry="lasso.ry" :transform="lasso.transform" />
        </svg>
        <div class="grid-container unselectable" @mouseup="cellReleased()">
          <div v-for="(cellObj, idx) in cells" :key="idx" v-bind:class="[cellObj.highlight ?  'highlight' : '', 'grid-item' ]" @mousedown="cellPressed(cellObj)" :id="idx" @mouseenter="cellRolled(cellObj)">{{ cellObj.char }}</div>
        </div>
      </div>
      <div class="words-container" @click="wordClicked()">
        <div class="words-heading">Words</div>
        <div v-for="(word, idx) in words" :key="idx" v-bind:class="[word.found ?  'word-crossed' : '', 'word' ]" class="word">{{ word.word }}</div>
      </div>
    </div>
    <div @click="goBack()" class="back">Go Back</div>
  </div>
</template>

<script>
export default {
  name: 'Wordsearch',
  data() {
    return {
      letters: 'EZEXHLNMGLBKEVOOODEMANIPRQAPKNLPICREHRSILWYJFAMHLREGITNEAZEBRAWT',
      wordlist: ['BEAR','CAMEL','ELEPHANT','GORILLA','HIPPO','LION','MONKEY','SNAKE','TIGER','ZEBRA'],
      words: [],
      rows: 8,
      cols: 8,
      cells: [],
      lassos: [],

      startCell: undefined,
      endCell: undefined
    }
  },
  beforeMount() {
    for(var row=0; row<this.rows; row++){

      for(var col=0; col<this.cols; col++){
        let i = (row*this.cols)+col;
        let c = this.letters.charAt(i);
        let cellObj = {char:c, highlight:false, index:i, row:row, col:col};
        this.cells.push(cellObj);
      }
    }
    for(var i=0; i<this.wordlist.length; i++){
      let w=this.wordlist[i];
      this.words.push({word:w, found:false});
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/')
    },
    cellPressed(cellObj) {
      this.startCell = cellObj;
      this.endCell = cellObj;
      this.highlight();
    },
    cellRolled(cellObj){
      if(this.startCell!=undefined){
        this.endCell = cellObj;
        this.highlight();
      }
    },
    cellReleased(){
      let selectedCells = this.selectCells();
      let letters = this.getStringFromCells(selectedCells);
      if(this.isWordInList(letters)){
        this.addLasso(letters);
      }
      this.startCell = undefined;
      this.endCell = undefined;
      this.unhighlight();
    },
    highlight(){
      this.unhighlight();
      let selectedCells = this.selectCells();
      for(var i=0; i<selectedCells.length; i++){
        let cell = selectedCells[i];
        cell.highlight = true;
      }
    },
    isWordInList(word){
      let rValue = false;
      let i = -1
      for(let j=0; j<this.words.length; j++){
        let w = this.words[j];
        if(w.word == word){
          i = j;
        }
      }

      if(i>=0){
        if(this.words[i].found == false){
          this.words[i].found = true;
          rValue = true;
        }
      }
      return rValue;
    },
    isHorizontal(){
      return this.endCell.row==this.startCell.row;
    },
    isVertical(){
      return this.endCell.col==this.startCell.col;
    },
    isAngle(){
      return Math.abs(this.endCell.row-this.startCell.row) == Math.abs(this.endCell.col-this.startCell.col);
    },
    addLasso(){
      let a=0;
      let count=0;
      let extraLength = 0;
      if(this.isVertical()){
        a=90;
        if(this.endCell.row<this.startCell.row){
          a=-90;
        }
        count = Math.abs(this.endCell.row-this.startCell.row);
      } else if(this.isHorizontal()){
        if(this.endCell.col<this.startCell.col){
          a=180;
        }
        count = Math.abs(this.endCell.col-this.startCell.col);
      } else if(this.isAngle()){
        a=45;
        extraLength = 24.4;
        if(this.endCell.row<this.startCell.row){
          a+=90;
        } 
        if(this.endCell.col<this.startCell.col){
          a+=90;
        }
        if(this.endCell.col>this.startCell.col && this.endCell.row<this.startCell.row){
          a+=180;
        }
        count = Math.abs(this.endCell.row-this.startCell.row); 
      }

      let h = 52;
      let w = 52+(count*60.3)+(count*extraLength);
      
      let x = 2+this.startCell.col*60.5;

      let y = 2+this.startCell.row*60;
      let transform = "";

      if(a<=0){ a+=360;}

      if(a>0){
        transform = "rotate("+a+" "+(x+26)+" "+(y+26)+")";
      }
      let lasso = {width:w, height:h, x:x, y:y, rx:25, ry:25, transform:transform, class:"lasso"};
      this.lassos.push(lasso);
    },
    selectCells(){
      let selectedCells = [];
      let x=0;
      let y=0;
      let count=0;

      if(this.isVertical()){
        y=1;
        if(this.endCell.row<this.startCell.row){
          y=-1;
        }
        count = Math.abs(this.endCell.row-this.startCell.row);
      } else if(this.isHorizontal()){
        x=1;
        if(this.endCell.col<this.startCell.col){
          x=-1;
        }
        count = Math.abs(this.endCell.col-this.startCell.col);
      } else if(this.isAngle()){
        x=1;
        y=1;
        if(this.endCell.row<this.startCell.row){
          y=-1;
        } 
        if(this.endCell.col<this.startCell.col){
          x=-1;
        }
        count = Math.abs(this.endCell.row-this.startCell.row); 
      }
      for(let i=0; i<count+1; i++){
          let c = this.startCell.col+(i*x);
          let r = this.startCell.row+(i*y);
          let j = (this.cols*r)+c;
          selectedCells.push(this.cells[j]);
      }
      return selectedCells;
    },
    getStringFromCells(cells){
      let rValue = "";
      for(var i=0; i<cells.length; i++){
        rValue+=cells[i].char;
      }
      return rValue;
    },
    unhighlight(){
      // iterate over all the elements and remove the highlight class
      for(var i=0; i<this.cells.length; i++){
        let cell = this.cells[i];
        cell.highlight = false;
      }
    },
    wordClicked(){
      console.log("hi");
    }
  }
}
</script>




<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wordsearch {
}
.grid-container {
  margin: 0 auto;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto auto auto;
  width: 480px;
  grid-column-gap: 5px;
  grid-row-gap: 5px;
  align-content: center;
  cursor:  all-scroll;
}
.grid-item {
  background-color: lightgray;
  height: 55px;
  width: 55px;
  padding-top: 2px;
  font-size: 28pt;  
}
.words-container {
  align-items: center;
  justify-content: center;
  width:  200px;
  padding-left: 10px;
}
.words-heading {
  background: darkgray;
  color: white;
}
.word {
  padding: 10px;
}
.word-crossed {
  text-decoration: line-through;
  text-decoration-style: wavy;
  text-decoration-color: red;
}
.highlight {
  background: lightblue;
}
.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
}
.wordsearch-container {
  position: relative;
  width:480px;
}
.wordsearch-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  pointer-events: none;
}
.lasso {
  fill:none;
  stroke-width:3;
  stroke:rgb(0,0,0);
}
.wordsearch-game {
  display:  flex;
  width: 640px;
  margin:0 auto;
  padding: 10px;
  border: 2px solid;
}
.back {
  margin-top: 40px;
}
</style>
